import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { MasterFSPMaintenanceProvider } from "presentation/store/MasterFSP/MasterFSPMaintenanceProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { MasterFSPMasterView } from "presentation/view/section/MasterFSP/MasterFSPMasterView";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const MasterFSPMaintenanceCont = () => {
    return <ANAInfoWrapper permission={Permission.MASTER_FSP_MAINTENANCE}>
        <MessageBarWrapper>
            <MasterFSPMaintenanceProvider>
                <GridStyles/>
                <MasterFSPMasterView/>
            </MasterFSPMaintenanceProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default MasterFSPMaintenanceCont;